import { ApiCore } from '@/services/api/utils/core.js'
import { apiProvider } from '@/services/api/utils/provider.js'
import { handleError, handleResponse } from '@/services/api/utils/response.js'
import axios from 'axios'

const url = 'sys'
// const url = 'pitstop'
const plural = 'pitstops'
const single = 'pitstop'

const api = new ApiCore({
	index: true,
	findOne: false,
	create: false,
	update: false,
	remove: true,
	url: url,
	plural: plural,
	single: single
})


api.index = () => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}`)
		.then(handleResponse)
		.catch(handleError);
}

api.plural = () => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}/${plural}`)
		.then(handleResponse)
		.catch(handleError);
}

api.delete = (id) => {
	return axios
		.delete(`${apiProvider.BASE_URL}/${url}/${id}`)
		.then(handleResponse)
		.catch(handleError);
}

export default api
